<template>
  <div id="boxCreazioneArticolo" class="sa-aggiungiarticolo sa-aggiungiarticolo-hidden">
    <magazzino-articoli-anagrafica-edit-component
      ref="cmpMagazzinoArticoliAnagraficaEditComponent"></magazzino-articoli-anagrafica-edit-component>
  </div>
</template>

<script>
import axios from "axios";
import MagazzinoArticoliAnagraficaEditComponent from "../../magazzino/components/MagazzinoArticoliAnagraficaEditComponent.vue";
export default {
  components: { MagazzinoArticoliAnagraficaEditComponent },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    showBox() {
      document.getElementById("boxCreazioneArticolo").classList.remove("sa-aggiungiarticolo-hidden");
      document.getElementById("boxCreazioneArticolo").classList.add("sa-aggiungiarticolo-visible");
      this.disabeConferma = true;
    },
    hideBox() {
      document.getElementById("boxCreazioneArticolo").classList.remove("sa-aggiungiarticolo-visible");
      document.getElementById("boxCreazioneArticolo").classList.add("sa-aggiungiarticolo-hidden");
      this.disabeConferma = true;
    },
    salvaNuovoArticolo() {
      let nuovoArticolo = this.$refs.cmpMagazzinoArticoliAnagraficaEditComponent.getJsonData();

      if (nuovoArticolo) {
        let pathResourceMagazzinoArticoli = process.env.VUE_APP_PATH_API + "/magazzinoarticoli";
        axios
          .post(pathResourceMagazzinoArticoli, nuovoArticolo)
          .then((response) => {
            response;
            this.hideBox();
            this.$emit("afterSavedArticolo");
          })
          .catch((error) => {
            if (error.response.data.messaggio) {
              this.generaBtoast(error.response.data.messaggio);
            }
          });
      }
    },
    generaBtoast(messaggio) {
      let message = messaggio.split("#");
      const h = this.$createElement;
      const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
      message.forEach((element) => {
        if (element.trim() != "") {
          vNodesMsg.children.push({ tag: "li", text: element });
        }
      });
      this.$bvToast.toast([vNodesMsg], {
        title: "Attenzione!",
        autoHideDelay: 5000,
        variant: "danger",
      });
    },
  },
};
</script>

<style scoped>
.sa-aggiungiarticolo {
  background-color: white;
  position: absolute;
  z-index: 100;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  top: 0;
  right: 0;
  left: 0;
  padding: 5px;
}

.sa-aggiungiarticolo-hidden {
  opacity: 0;
  visibility: hidden;
  transition: all 1s ease-in-out;
}

.sa-aggiungiarticolo-visible {
  visibility: visible;
  opacity: 1;
  transition: all 1s ease-in-out;
}
</style>
